var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-account-group ")]
                  ),
                  _vm._v(" Administração > Gerenciamento de Login Social ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "pa-3 mb-4",
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.aplicarFiltros.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-row",
                { staticClass: "pa-5 d-flex align-center" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-row pa-0 pb-3 responsive",
                      attrs: { cols: "12", sm: "6", md: "4", lg: "3" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar por nome, email",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          clearable: "",
                          "prepend-inner-icon": "mdi-magnify",
                          "data-cy": "filtroGlobal"
                        },
                        model: {
                          value: _vm.filtroGlobal,
                          callback: function($$v) {
                            _vm.filtroGlobal = $$v
                          },
                          expression: "filtroGlobal"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-row pa-0 pb-3",
                      attrs: { cols: "12", sm: "6", md: "3", lg: "2" }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.perfilOptions,
                          label: "Filtrar por Perfil",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          clearable: "",
                          "data-cy": "filtroPerfil"
                        },
                        model: {
                          value: _vm.filtroPerfil,
                          callback: function($$v) {
                            _vm.filtroPerfil = $$v
                          },
                          expression: "filtroPerfil"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "d-flex justify-end justify-sm-end justify-md-end align-center pa-0",
                      attrs: { cols: "12", sm: "12", md: "5", lg: "7" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap justify-end" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2 mb-2 mb-lg-",
                              attrs: {
                                color: "primary",
                                disabled: _vm.loading,
                                "data-cy": "btnFiltrar"
                              },
                              on: { click: _vm.aplicarFiltros }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-magnify")
                              ]),
                              _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [_vm._v("Filtrar")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2 mb-2 mb-sm-0",
                              attrs: {
                                outlined: "",
                                color: "secondary",
                                disabled: _vm.loading,
                                "data-cy": "btnLimpar"
                              },
                              on: { click: _vm.limparFiltros }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-filter-remove")
                              ]),
                              _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [_vm._v("Limpar")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-2 mb-sm-0",
                              attrs: {
                                color: "success",
                                disabled: _vm.loading,
                                "data-cy": "btnNovo"
                              },
                              on: { click: _vm.abrirModalNovo }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [_vm._v("NOVO")]
                              ),
                              _c(
                                "span",
                                { staticClass: "d-inline d-sm-none" },
                                [_vm._v("Login Social")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.loginsSociais,
                  loading: _vm.loading,
                  "footer-props": {
                    itemsPerPageOptions: [10, 20, 50],
                    itemsPerPageText: "Itens por página:"
                  },
                  "item-key": "id",
                  "item-class": _vm.getRowClass,
                  "server-items-length": _vm.totalItems,
                  page: _vm.currentPage,
                  "items-per-page": _vm.itemsPerPage,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc
                },
                on: {
                  "update:page": [
                    function($event) {
                      _vm.currentPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:itemsPerPage": function($event) {
                    _vm.itemsPerPage = $event
                  },
                  "update:items-per-page": [
                    function($event) {
                      _vm.itemsPerPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": [
                    function($event) {
                      _vm.sortBy = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": [
                    function($event) {
                      _vm.sortDesc = $event
                    },
                    _vm.carregarDados
                  ]
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.perfil`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-chip",
                            {
                              staticClass: "perfil-chip",
                              attrs: {
                                color: _vm.getPerfilColor(item.perfil),
                                "text-color": "white",
                                small: ""
                              }
                            },
                            [_vm._v(" " + _vm._s(item.perfil) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: `item.apresentantes`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.truncarApresentantes(item.apresentantes)
                                  )
                                )
                              ]),
                              item.apresentantes.length > 3
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "primary"
                                                        }
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " mdi-dots-horizontal "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.apresentantes
                                              .map(ap => ap.cd_apresentante)
                                              .join(", ")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: `item.acoes`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: "info",
                                                  "data-cy": "btnDetalhes"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.abrirModalEdicao(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("mdi-eye")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("Detalhes")])]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.modalAtivo
        ? _c("ModalLoginSocial", {
            attrs: {
              showModal: _vm.modalAtivo,
              loginSocial: _vm.loginSocialSelecionado,
              modoEdicao: _vm.modoEdicao,
              apresentantesDisponiveis: _vm.apresentantesDisponiveis
            },
            on: {
              fecharModal: _vm.fecharModal,
              mostrarMensagem: _vm.mostrarMensagem,
              atualizarLista: _vm.carregarDados
            }
          })
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: "5000",
            top: "",
            right: ""
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Fechar ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }